import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import FacilityService from "../../services/FacilityServices";

const FacilityForm = ({ open, onClose, onSave }) => {
  const [facility, setFacility] = useState({
    federalId: "",
    subCode: "",
    name: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipCode: "",
    class: "Hospital/Clinic",
    isActive: true,
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFacility({ ...facility, [name]: value });
  };
  const handleClose = () => {
    resetForm();
    onClose();
  };

  const resetForm = () => {
    setFacility({
      federalId: "",
      subCode: "",
      name: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zipCode: "",
      class: "Hospital/Clinic",
      isActive: true,
    });
  };

  const handleSubmit = async () => {
    const validationErrors = {};
    // Check for required fields
    if (!facility.federalId)
      validationErrors.federalId = "Federal ID is required";
    if (!facility.name) validationErrors.name = "Facility Name is required";
    if (!facility.address1) validationErrors.address1 = "Address 1 is required";
    if (!facility.city) validationErrors.city = "City is required";
    if (!facility.state) validationErrors.state = "State is required";
    if (!facility.zipCode) validationErrors.zipCode = "ZIP Code is required";
    if (!facility.class) validationErrors.class = "Class is required";

    // If there are errors, set them in the state and do not proceed with submission
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    try {
      const response = await FacilityService.create(facility);
      onSave(response.data);
      resetForm();
      onClose();
    } catch (error) {
      console.error("Error creating facility:", error);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>Add New Facility</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              margin="normal"
              label="Federal ID"
              name="federalId"
              value={facility.federalId}
              onChange={handleChange}
              required
              error={!!errors.federalId}
              helperText={errors.federalId}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              margin="normal"
              label="Sub Code"
              name="subCode"
              value={facility.subCode}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              margin="normal"
              label="Facility Name"
              name="name"
              value={facility.name}
              onChange={handleChange}
              required
              error={!!errors.name}
              helperText={errors.name}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              margin="normal"
              required
              label="Address 1"
              name="address1"
              value={facility.address1}
              onChange={handleChange}
              error={!!errors.address1}
              helperText={errors.address1}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              margin="normal"
              label="Address 2"
              name="address2"
              value={facility.address2}
              onChange={handleChange}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              margin="normal"
              label="City"
              name="city"
              value={facility.city}
              onChange={handleChange}
              required
              error={!!errors.city}
              helperText={errors.city}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              margin="normal"
              required
              label="State"
              name="state"
              value={facility.state}
              onChange={handleChange}
              error={!!errors.state}
              helperText={errors.state}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              margin="normal"
              required
              label="ZIP Code"
              name="zipCode"
              value={facility.zipCode}
              onChange={handleChange}
              error={!!errors.zipCode}
              helperText={errors.zipCode}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              fullWidth
              margin="normal"
              label="Class"
              name="class"
              value={facility.class}
              onChange={handleChange}
              required
              error={!!errors.class}
              helperText={errors.class}
            />
          </Grid>
          {/* Uncomment if using the isActive switch */}
          {/* <Grid item xs={12} sm={6}>
            <FormControlLabel
              control={
                <Switch
                  checked={facility.isActive}
                  onChange={handleSwitchChange}
                  name="isActive"
                  color="primary"
                />
              }
              label="Is Active"
            />
          </Grid> */}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Cancel
        </Button>
        <Button onClick={handleSubmit} color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FacilityForm;
